export enum ExtensionEligibilityGroups {
  NORMAL = 'normal-plans',
  SPECIAL = 'special-plans',
}

export interface ContractExtensionOption {
  url: string;
  period: number;
  price: number;
}

export interface ContractExtensionEligibilityInfo {
  isExpired: boolean;
  extensionOptions: ContractExtensionOption[];
  group: ExtensionEligibilityGroups;
}
